import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import Modal from '../../../../common/modal/Modal';
import Badge from '../../../../common/Badge';
import BaggageManifestAddItem from './BaggageManifestAddItem';

const BaggageManifestDefaultButtons = ({
  selectedItineraryId,
  disablePrintButton,
  disableAddItemButton,
  handlePrintBaggageManifest,
  handleReload,
  disableReloadButton,
  isManifestPrinted,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [bodyModal, setBodyModal] = useState(null);
  const [titleModal, setTitleModal] = useState(null);

  const handleCloseModal = () => {
    setShowModal(false);
    setBodyModal(null);
    setTitleModal(null);
  };

  return (
    <>
      <Modal
        show={showModal}
        title={titleModal}
        body={bodyModal}
        onClickClose={handleCloseModal}
      />
      <div className="d-flex justify-content-between align-items-end mb-3">
        <div>
          {isManifestPrinted && (
            <Badge color="success" text="Manifiesto Impreso" />
          )}
        </div>
        <div>
          <BaggageManifestAddItem
            selectedItineraryId={selectedItineraryId}
            isManifestPrinted={isManifestPrinted}
            disabled={disableAddItemButton}
          />

          <Button
            color="secondary"
            type="button"
            onClick={handlePrintBaggageManifest}
            disabled={disablePrintButton}
            className="mr-2"
          >
            <i className="fa fa-print" /> Imprimir Manifiesto
          </Button>
          <Button
            color="info"
            onClick={handleReload}
            disabled={disableReloadButton}
          >
            <i className="fa fa-refresh" /> Actualizar
          </Button>
        </div>
      </div>
    </>
  );
};

BaggageManifestDefaultButtons.propTypes = {
  selectedItineraryId: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]),
  disablePrintButton: PropTypes.bool,
  disableAddItemButton: PropTypes.bool,
  handlePrintBaggageManifest: PropTypes.func,
  handleReload: PropTypes.func.isRequired,
  disableReloadButton: PropTypes.bool,
  isManifestPrinted: PropTypes.bool,
};

BaggageManifestDefaultButtons.defaultProps = {
  selectedItineraryId: null,
  disablePrintButton: false,
  disableAddItemButton: false,
  handlePrintBaggageManifest: () => {},
  disableReloadButton: false,
  isManifestPrinted: false,
};

export default BaggageManifestDefaultButtons;
